import React, { useEffect, useState } from 'react';
import { UserBankAccount, BankAccount, SetLoading } from '../SiteClasses';
import { useTranslation } from 'react-i18next';
import { bindClick } from '../SiteUtil';
import { useBreadcrumbs } from '../hooks';
import { Header, Table, Button, Icon, Toast, Modal, Message } from 'react-frontier';
import BankAccountModal from '../components/BankAccountModal';
import API from '../API';

var UserAccounts = ()=>{
	var { t } = useTranslation();
	var { setTitle } = useBreadcrumbs();
	var [loadError, setLoadError] = useState<string>(null);
	var [accounts, setAccounts] = useState<UserBankAccount[]>(null);
	var [addModal, setAddModal] = useState<boolean>(false);
	var [selectedAccount, setSelectedAccount] = useState<UserBankAccount>(null);
	var [deleteModal, setDeleteModal] = useState<boolean>(false);
	var [modalPrompts, setModalPrompts] = useState<string[]>(null);

	useEffect(()=>{
		setTitle('Mis cuentas');
		API.getUserBankAccounts().then(res=>{
			if (res.error) return setLoadError(res.message);
			setAccounts(res.data);
		}).catch(err=>{
			return setLoadError('Hubo un error al solicitar las cuentas. (GUA-1)');
		})
	}, []);

	var onCreateAccount = (account: BankAccount)=>{
		setAddModal(false);
		Toast.success('Se ha agregado la cuenta bancaria a tu cuenta');
		var ac = [...accounts];
		ac.push(account);
		setAccounts(ac);
	};

	var onEditAccount = (account_id: number, account: BankAccount)=>{
		setAddModal(false);
		setSelectedAccount(null);
		Toast.success('Se ha editado la cuenta bancaria');
		var ac = [...accounts];
		var aix = ac.findIndex(a=>a.account_id===account_id);
		if(aix!=-1){
			ac[aix] = account;
			setAccounts(ac);
		}
	};

	var onShowDelete = (account: UserBankAccount)=>{
		setSelectedAccount(account);
		setDeleteModal(true);
	};

	var deleteAccount = (setLoading: SetLoading)=>{
		setLoading(true);
		API.deleteUserBankAccount(selectedAccount.account_id).then(res=>{
			if(res.error) return setModalPrompts([res.message]);
			Toast.success('Cuenta bancaria eliminada');
			setAccounts(prev => prev.filter(a => a.account_id !== selectedAccount.account_id));
			setDeleteModal(false);
			setSelectedAccount(null);
		}).catch(err=>{
			setModalPrompts(['Hubo un error inesperado eliminando la cuenta (LCL-1)']);
		}).finally(()=>{
			setLoading(false);
		});
	};

	
	if(loadError) return <Header text='Error' subtext={loadError} />;
	if(!accounts) return <Header text='Cargando datos' loading/>;

	return <div className='ar bank-accounts-screen'>
		<Table
			style={{ maxWidth: 700, margin: 'auto', marginTop: 20 }}
			title='Mis cuentas bancarias'
			striped
			headers={['ID', 'Tipo', 'Titular', 'Banco', 'Cuenta', <Icon name='wrench' />]}
			collapsingIndexes={[5]}
			button={
				<Button 
					text='Agregar' 
					color='black' 
					iconName='plus-circle' 
					size='small' 
					onClick={bindClick(setAddModal, true)} 
				/>
			}
		>
			{accounts.length === 0 ? (
				<Table.Cell row className='empty' colSpan={6}>
					<Header 
						iconName='landmark' 
						text='Sin cuentas bancarias'
						subtext='Agrega una cuenta bancaria para recibir tus pagos'
						style={{ marginTop: 40}}
					/>
				</Table.Cell>
			) : (
				accounts.map(a => (
					<Table.Row
						key={a.account_id}
						data={[
							a.account_id,
							<>
								<Icon name={a.clabe ? 'landmark' : 'credit-card'} style={{ marginRight: 5 }} />
								{a.clabe ? 'SPEI' : 'Tarjeta'}
							</>,
							a.name_account,
							a.bank,
							a.clabe ? `**${a.clabe.slice(-5)}` : `**${a.card_number.slice(-4)}`,
							<Button size='tiny' iconName='trash' onClick={() => onShowDelete(a)} name='trash' />
						]}
					/>
				))
			)}
		</Table>
		<BankAccountModal
			open={addModal}
			onClose={()=>{
				setAddModal(false);
			}}
			onCreate={onCreateAccount}
		/>
		<Modal open={deleteModal} onClose={bindClick(setDeleteModal, false)} size='tiny'>
			<Modal.Header>Eliminar cuenta bancaria</Modal.Header>
			{selectedAccount && <Modal.Content>
				<Header text='¿Eliminar cuenta bancaria?' subheaderStyle={{ marginTop: 8, marginBottom: 15 }} />
				<Table
					details
					titleSize='small'
					title='Detalles'
					data={[
						['ID', selectedAccount.account_id],
						['Titular', selectedAccount.name_account],
						['Banco', selectedAccount.bank],
						['Tipo', selectedAccount.clabe ? 'SPEI (Transferencia)' : 'Tarjeta bancaria'],
						[selectedAccount.clabe ? 'CLABE' : 'Tarjeta', selectedAccount.clabe || selectedAccount.card_number]
					]}
				/>
				<Message type="error" list={modalPrompts} />
			</Modal.Content>}
			<Modal.Actions>
				<Button text='Cerrar' basic onClick={bindClick(setDeleteModal, false)} />
				<Button onClick={deleteAccount} text='Eliminar' color='red'/>
			</Modal.Actions>
		</Modal>
	</div>
}

export default UserAccounts;